import React from 'react';
import styles from './PriceLabel.module.scss';

export default function PriceLabel({ value, fullPrice }: {
  value: number | string;
  fullPrice?: number;
}) {
  const isPrice = typeof value === 'number';
  const displayValue = isPrice ? `$${value}` : value;

  return (
    <>
      <div className={styles.PriceLabel}>
        {fullPrice && <span className={styles.FullPrice}>${fullPrice}</span>}
        <span>{displayValue}</span>
      </div>
    </>
  );
}
